import React from 'react';
import MatchTable from '../Common/MatchTable';
import { Remark } from '../Common/MatchBase';

const TEAMFHL = () => {
    return (
        <section className='TEAMFHL'>
            <MatchTable betType='TEAMFHL'/>
            <Remark />
        </section>
    )
}
export default TEAMFHL;